import React from 'react';

interface BidAskBarChartProps {
  askPercentage: number;
  bidPercentage: number;
  neutralPercentage?: number;
  className?: string;
}

export const BidAskBarChart: React.FC<BidAskBarChartProps> = ({
  askPercentage,
  bidPercentage,
  neutralPercentage = 0,
  className = ''
}) => {
  // Calculate total percentage for scaling
  const totalPercentage = askPercentage + bidPercentage + neutralPercentage;
  
  // Normalize percentages if they don't sum to 100
  const normalizedAsk = totalPercentage > 0 ? (askPercentage / totalPercentage) * 100 : 0;
  const normalizedBid = totalPercentage > 0 ? (bidPercentage / totalPercentage) * 100 : 0;
  const normalizedNeutral = totalPercentage > 0 ? (neutralPercentage / totalPercentage) * 100 : 0;

  return (
    <div className={`bid-ask-chart ${className}`}>
      <div className="bid-ask-bar">
        {/* Ask (Green) segment */}
        {normalizedAsk > 0 && (
          <div 
            className="bid-ask-segment bid-ask-ask"
            style={{ width: `${normalizedAsk}%` }}
            title={`Ask: ${askPercentage.toFixed(1)}%`}
          >
            {normalizedAsk > 15 && (
              <span className="bid-ask-label">
                {askPercentage.toFixed(0)}%
              </span>
            )}
          </div>
        )}
        
        {/* Bid (Red) segment */}
        {normalizedBid > 0 && (
          <div 
            className="bid-ask-segment bid-ask-bid"
            style={{ width: `${normalizedBid}%` }}
            title={`Bid: ${bidPercentage.toFixed(1)}%`}
          >
            {normalizedBid > 15 && (
              <span className="bid-ask-label">
                {bidPercentage.toFixed(0)}%
              </span>
            )}
          </div>
        )}
        
        {/* Neutral (Gray) segment */}
        {normalizedNeutral > 0 && (
          <div 
            className="bid-ask-segment bid-ask-neutral"
            style={{ width: `${normalizedNeutral}%` }}
            title={`Neutral: ${neutralPercentage.toFixed(1)}%`}
          >
            {normalizedNeutral > 15 && (
              <span className="bid-ask-label">
                {neutralPercentage.toFixed(0)}%
              </span>
            )}
          </div>
        )}
      </div>
      
      {/* Show percentages below the bar if segments are too small for labels */}
      {(normalizedAsk <= 15 || normalizedBid <= 15 || normalizedNeutral <= 15) && (
        <div className="bid-ask-percentages">
          {normalizedAsk > 0 && (
            <span className="bid-ask-percentage ask-percentage">
              Ask: {askPercentage.toFixed(0)}%
            </span>
          )}
          {normalizedBid > 0 && (
            <span className="bid-ask-percentage bid-percentage">
              Bid: {bidPercentage.toFixed(0)}%
            </span>
          )}
          {normalizedNeutral > 0 && (
            <span className="bid-ask-percentage neutral-percentage">
              Neutral: {neutralPercentage.toFixed(0)}%
            </span>
          )}
        </div>
      )}
    </div>
  );
};
